import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
} from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "../constant/constant";

import CachedIcon from '@mui/icons-material/Cached';
export default function EncryptDecryptTool() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");
const token = localStorage.getItem("token");
  const handleEncrypt = async () => {
    try {
      const res = await axios.post(`${API_BASE_URL}/api/vbencrypt`, { text: input });
      setOutput(res.data.cipher);
    } catch (err) {
      setOutput("Error: " + (err.response?.data?.error || err.message));
    }
  };

  const handleDecrypt = async () => {
    try {
      const res = await axios.post(`${API_BASE_URL}/api/vbdecrypt`, { cipher: input } ,{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});
      setOutput(res.data.text);
    } catch (err) {
      setOutput("Error: " + (err.response?.data?.error || err.message));
    }
  };

  useEffect(() => {
    if (!open) {
      setInput("");
      setOutput("");
    }
  }, [open]);

  return (
    <div>
      {/* Button to open dialog */}
      <Button  startIcon={<CachedIcon />}
        variant="outlined"
       color="primary"
        fullWidth
        sx={{
          py: 1.5,
       //   fontWeight: "bold",
          borderRadius: 3,
          textTransform: "none",
        }} onClick={() => setOpen(true)}>
        Encrypt/Decrypt
      </Button>

      {/* Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor: "primary.main", color: "white", fontWeight: "bold" }}>Encrypt / Decrypt</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              label="Input (Plain or Cipher)"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              fullWidth
              multiline
            />
            <TextField
              label="Output"
              value={output}
              fullWidth
              multiline
              InputProps={{ readOnly: true }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEncrypt} variant="contained" color="primary">
            Encrypt
          </Button>
          <Button onClick={handleDecrypt} variant="contained" color="secondary">
            Decrypt
          </Button>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
